import { ApiConstant } from "const";
import { createApiWithToken } from "services/config/api.config";

export const getWeatherData = data => createApiWithToken().get(ApiConstant.GET_WEATHER_DATA, data);
